import { getProductCodeFromParsedToken, getUserIdFromParsedToken, getWorkstationIdFromParsedToken, parseAuthToken } from './auth-token-utils';
import { getSessionId } from './get-session-id';
import { getUuid } from './get-uuid';
/**
 * Returns a unique correlation ID for a specific API request via the [[OcapiClient.Correlation]] header.
 */
export const getCorrelationId = (config, token) => {
    var _a, _b;
    const parsedToken = parseAuthToken(token);
    let clientId = (_a = getProductCodeFromParsedToken(parsedToken)) !== null && _a !== void 0 ? _a : config.clientId;
    clientId = clientId.replaceAll('.', '');
    let userId = (_b = getWorkstationIdFromParsedToken(parsedToken)) !== null && _b !== void 0 ? _b : getUserIdFromParsedToken(parsedToken);
    userId = userId.replaceAll('|', '');
    const requestId = getUuid();
    return `${clientId}-${userId}-${getSessionId()}-${requestId}`;
};
//# sourceMappingURL=get-correlation-id.js.map